import { IMeeetingAgenda } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

export const getMeetingAgendaInitialData = (
  meetingDataTime: string | undefined
): IMeeetingAgenda[] => {
  return [
    {
      Topic: '',
      Time: 0,
      Schedule: { Start: meetingDataTime || null, End: meetingDataTime || null },
      Presenter: '',
    },
  ]
}
